//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Category",1,0],[0,"CollisionFactor",1,0],[0,"CollisionShape",1,0],[0,"DetectionType",1,0],[1,"Geometry",0,"SelectNXObjectList",0],[0,"HighlightOnCollision",1,0],[0,"Name",1,0],[0,"SensorType",1,0],[0,"ShapeProperties",1,0],[0,"ShowName",1,0]],[[["geometries"],"SetGeometry",{},1,0],[[],"CalculateMesh",{},0,0],[[],"CalculateConvex",{},0,0],[[],"CalculateMultiConvex",{},0,0]],[]];
SPLM.Mechatronics.CollisionSensorBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.CollisionSensorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.CollisionSensorBuilder.CollisionShapeTypes = Object.freeze({
    "Box" : "Box", "Sphere" : "Sphere", "Line" : "Line", "Cylinder" : "Cylinder", "Mesh" : "Mesh", "Convex" : "Convex", "MultiConvex" : "MultiConvex"});

SPLM.Mechatronics.CollisionSensorBuilder.ShapePropertiesOption = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

SPLM.Mechatronics.CollisionSensorBuilder.SensorTypes = Object.freeze({
    "Trigger" : "Trigger", "Switcher" : "Switcher"});

SPLM.Mechatronics.CollisionSensorBuilder.DetectionTypes = Object.freeze({
    "System" : "System", "User" : "User", "Both" : "Both"});

export default SPLM;